import {
  VitalsAggregateResult,
  VitalsQueryParams,
  VitalsAggregateMeasureResult,
  VitalsMeasurementRequest,
} from '@quromedical/models';
import { trpc } from 'trpc';

export type VitalsAggregateMergedResult = Omit<VitalsAggregateResult, 'next'>;

export class VitalsApi {
  public async getVitals(params: VitalsQueryParams): Promise<VitalsAggregateMergedResult> {
    return await trpc.client.vitals.getByPatient.query(params);
  }

  public async getTracking(params: VitalsQueryParams): Promise<VitalsAggregateMergedResult> {
    return await trpc.client.vitals.getByTracking.query(params);
  }

  public async getVitalsByMeasurement(
    params: VitalsMeasurementRequest
  ): Promise<VitalsAggregateMeasureResult> {
    return await trpc.client.vitals.getByName.query({
      ...params,
    });
  }
}
